import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import LocationIcon from 'assets/img/svg/location-icon.svg'
import PromoterIcon from 'assets/img/svg/nps-promoter.svg'
import ClockIcon from 'assets/img/svg/nps-detractor.svg'
import ClosedIcon from 'assets/img/svg/nps-passive.svg'
import { queries } from '~/constants/mediaQuery'

function NPSCard({ promoters = 0, detractors = 0, neutrals = 0, total = 0 }) {
  return (
    <StatusGrid>
      <div className="status-card">
        <div className="card-content">
          <div className="card-info">
            <div className="card-title">
              <span>
                <FormattedMessage id="Total reviews" />
              </span>
            </div>
            <span>{total}</span>
          </div>
          <div className="card-icon total">
            <img src={LocationIcon} width="40px" alt="" />
          </div>
        </div>
      </div>

      <div className="status-card">
        <span>
          5 <FormattedMessage id="stars" />
        </span>
        <div className="card-content">
          <div className="card-info">
            <div className="card-title">
              <span>
                <FormattedMessage id="Promoters" />{' '}
              </span>
            </div>
            <span>{promoters}</span>
          </div>
          <div className="card-icon open">
            <img src={PromoterIcon} width="56px" alt="" />
          </div>
        </div>
      </div>

      <div className="status-card">
        <span>
          3-4 <FormattedMessage id="stars" />
        </span>
        <div className="card-content">
          <div className="card-info">
            <div className="card-title">
              <span>
                <FormattedMessage id="Neutrals" />
              </span>
            </div>
            <span>{neutrals}</span>
          </div>
          <div className="card-icon closed">
            <img src={ClosedIcon} width="56px" alt="" />
          </div>
        </div>
      </div>

      <div className="status-card">
        <span>
          1-2 <FormattedMessage id="stars" />
        </span>

        <div className="card-content">
          <div className="card-info">
            <div className="card-title">
              <span>
                <FormattedMessage id="Detractors" />
              </span>
            </div>
            <span>{detractors}</span>
          </div>
          <div className="card-icon temp">
            <img src={ClockIcon} width="56px" alt="" />
          </div>
        </div>
      </div>
    </StatusGrid>
  )
}

const StatusGrid = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  @media ${queries.less.mds} {
    overflow-x: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    &::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
    margin-left: calc(-1 * (2.2rem));
    margin-right: calc(-1 * (2.2rem));
    padding: 0 2.2rem 0;
  }

  @media ${queries.less.xll} {
    overflow-x: scroll;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    &::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
    margin-left: calc(-1 * (2.2rem - 1rem));
    margin-right: calc(-1 * (2.2rem - 1rem));
    padding: 0 calc(2.2rem - 1rem);
  }

  .status-card {
    flex: 1 0 0;
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: #fff;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
    > span {
      color: #a8a8a8;
      font-size: 12px;
      white-space: nowrap;
    }

    .card-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;
      gap: 8px;
      .card-info {
        flex: 1 0 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: start;
        > span {
          color: #1a202c;
          font-size: 28px;
          font-weight: 600;
          white-space: nowrap;
        }
        .card-title {
          height: 32px;
          display: flex;
          align-items: center;
          gap: 4px;
          margin-bottom: 0px;
          > span {
            color: #2c2c2c;
            font-size: 16px;
            gap: 4px;
            white-space: nowrap;
          }
          > .metric {
            display: flex;
            width: 32px;
            height: 32px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            border-radius: 999px;
            border: 1px solid #edf2f7;
            background: #f7fafc;
            > span {
              color: #4a5568;
              font-size: 13px;
              font-weight: 600;
              letter-spacing: -0.26px;
            }
          }
        }
      }
      @media ${queries.less.sm} {
        width: 233px;
      }
    }

    .card-icon {
      display: flex;
      width: 56px;
      height: 56px;
      padding: 10px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 8px;

      &.total {
        background-color: #8176f1;
      }

      &.open {
        // background-color: #38a169;
        padding: 0;
      }

      &.closed {
        // background-color: #f6ad55;
        padding: 0;
      }

      &.temp {
        // background-color: #c53030;
        padding: 0;
      }
    }
  }
`

export default NPSCard
